import { destroy2 } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";

type PaymentLedgerDelete = {
  orderId: number;
  ledgerId: number;
};

const usePaymentLedgerDelete = () => {
  const mutation = useMutation({
    mutationFn: ({ orderId, ledgerId }: PaymentLedgerDelete) =>
      destroy2(
        `internal/secure/pos/v1/orders/split-payments/${orderId}/${ledgerId}`
      ),
  });

  return mutation;
};

export default usePaymentLedgerDelete;
